
import axios from "axios";

async function sendOTPMessage(body) {
    const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'message/sendOTPMessage', body)
    return response;
}

async function sendMailTo(body) {
    const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'mail/sendMailTo', body)
    return response;
}

async function sendOTPMessageMail(body) {
    const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'message/sendOTPMessageToMail', body)
    return response;
}

async function sendMessage(body){
    const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'message/sendMessage', body)
    return response;
}

async function sendOTPMessageForLeadRegistration(body) {
    const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL+'message/sendOTPMessageForLeadRegistration', body)
    return response;
}
export {  sendOTPMessage,sendMailTo,sendMessage , sendOTPMessageMail,sendOTPMessageForLeadRegistration }